
export default function login( state = [], action = {} ){

	switch( action.type ){
		case 'SEND_AUTH':
			return action.login
		case 'DIS_AUTH':
			return action.payload
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/login/login.reducer.js